import { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FirebaseError } from 'firebase/app';
import { signInWithEmailAndPassword, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { AccountForgottenPassword } from './AccountForgottenPassword';
import { AccountFederatedSignIn } from './AccountFederatedSignIn';
import { convertSessionToAccountSkitterbooks } from '../Utils/AccountUtils';
import { auth } from '../Services/firebase';

export function AccountSignIn({ onSuccess }: {
    onSuccess: (name: string, count: number) => void;
}) {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [showForgot, setShowForgot] = useState(false);

    const handleSignIn = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            if (auth.currentUser !== null) {
                const credential = EmailAuthProvider.credential(email, password);
                await reauthenticateWithCredential(auth.currentUser, credential);
            }
            else {
                await signInWithEmailAndPassword(auth, email, password);
            }
            const res = await convertSessionToAccountSkitterbooks();
            onSuccess(auth.currentUser?.displayName || 'Skitterbooker', res.count);
        } catch (err: unknown) {
            if (err instanceof FirebaseError) {
                setError(err.message); // or err.code for granular handling
            } else {
                setError('Unexpected error');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Form onSubmit={handleSignIn}>
                <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="you@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="••••••••"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </Form.Group>

                {error && <div className="text-danger mb-2">{error}</div>}

                <Button variant="outline-primary" type="submit" disabled={loading}>
                    {loading ? 'Signing in…' : 'Sign In'}
                </Button>

                <Button variant="outline-secondary" type="button" className="link-button" onClick={() => setShowForgot(true)}>
                    Forgot your password?
                </Button>
            </Form>
            <AccountForgottenPassword show={showForgot} onHide={() => setShowForgot(false)} />

            <AccountFederatedSignIn />
        </div>
    );
}
